import gql from "graphql-tag";

export const DELETE_EQUIPMENT = gql`
  mutation DeleteEquipment($equipmentId: ID!, $dynamicsVendorOpportunityId: ID!, $vendorOpportunityId: ID!) {
    deleteEquipment(
      equipmentId: $equipmentId
      vendorOpportunityId: $vendorOpportunityId
      dynamicsVendorOpportunityId: $dynamicsVendorOpportunityId
    )
  }
`;
